(function () {
  const init = () => {
    document.querySelectorAll('.brand-apart-comparison-section').forEach((section) => {
      if (section.dataset.brandApartToggleReady === 'true') return;
      section.dataset.brandApartToggleReady = 'true';

      const toggle = section.querySelector('[data-brand-apart-show-more]');
      const rows = Array.from(section.querySelectorAll('[data-brand-apart-row-hidden]'));

      if (!(toggle instanceof HTMLButtonElement) || !rows.length) return;

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;

        rows.forEach((row) => {
          row.hidden = !nextExpanded;
        });

        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        toggle.textContent = nextExpanded
          ? toggle.dataset.expandedLabel || 'Show less'
          : toggle.dataset.collapsedLabel || 'Show more';
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
